
import uiBottom from '@/component/uiBottom'
import uiRadio from '@/component/uiRadio'
import uiChecker from '@/component/uiChecker'
import Datetime from 'vux/src/components/datetime/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
components: {
uiBottom,
uiRadio,
uiChecker,
Datetime,
Group
},
data () {
return {
valid: {
repeat: false
},
userInfo: {
userName: '',
userPhone: '',
sex: 0,
age: '',
email: '',
birthday: '2017-10-11'
},
extra: {},
index: 0,
userNameReg: [{
rule: /^\s*$/,
tips: '請輸入中文全名'
}],
userPhoneReg: [
{
rule: /^\s*$/,
tips: '請輸入电话号码'
}, {
flag: true,
rule: /^[456789]\d{7}$/,
tips: '請輸入正确电话号码'
}
],
ageReg: [{
flag: true,
rule: /^[1-9]\d{0,2}$/,
tips: '請輸入正确年龄'
}],
emailReg: [{
flag: true,
rule: /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/,
tips: '請輸入正确邮箱'
}]
}
},
watch: {
'userInfo.email': function (v) {
for (let i in this.extra) {
if (this.extra[i].checkEmail) {
this.extra[i].email = v
}
}
}
},
methods: {
jump () {
if (this.$valid()) {
console.log('校验通过')
console.log(this.userInfo)
console.log(this.extra)
this.valid.repeat = true
}
},
addExtra () {
this.$set(this.extra, this.index, {
userName: '',
userPhone: '',
sex: 0,
age: '',
email: '',
checkEmail: false
})
this.index++
},
changeCheckbox (i) {
if (this.extra[i].checkEmail) {
this.extra[i].email = this.userInfo.email
} else {
this.extra[i].email = ''
}
},
delExtraExe (i) {
this.$delete(this.extra, i)
}
}
}



// WEBPACK FOOTER //
// ./src/page/demo/form.vue